import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo } from 'react';
import { createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import SummaryBox from "./SummaryBox";
import { TABLES } from "../../../constants";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Summary');
const defaultSettings = {
  users: {
    text: 'label_sage_summary_1',
    text2: 'label_sage_summary_1_variable'
  },
  accountTypes: {
    text: 'label_sage_summary_2',
    text2: 'label_sage_summary_2_variable'
  },
  orderStatus: {
    text: 'label_sage_summary_3',
    text2: 'label_sage_summary_3_variable'
  },
  opportunityStatus: {
    text: 'label_sage_summary_4',
    text2: 'label_sage_summary_4_variable'
  }
};
const Summary = /*#__PURE__*/memo(_ref => {
  let {
    count = {},
    settings = defaultSettings
  } = _ref;
  const classes = useStyles();
  const theme = useTheme();
  const info = [_objectSpread({
    icon: 'emailSendOutline',
    iconColor: theme.colors.actionMajor[450],
    secondaryColor: theme.colors.semantic.positive500,
    param: count[TABLES.INVITED_USERS]
  }, settings.users), _objectSpread({
    icon: 'branchCheck',
    iconColor: theme.colors.actionMajor[450],
    secondaryColor: theme.colors.semantic.positive500,
    param: count[TABLES.ACCOUNT_TYPES]
  }, settings.accountTypes), _objectSpread({
    icon: 'quotesOutlined',
    iconColor: theme.colors.actionMajor[450],
    secondaryColor: theme.colors.semantic.positive500,
    param: count[TABLES.SALES_ORDER_STATUS]
  }, settings.orderStatus), _objectSpread({
    icon: 'databaseExport',
    iconColor: theme.colors.actionMajor[450],
    secondaryColor: theme.colors.semantic.positive500,
    param: count[TABLES.OPPORTUNITY_STATUS]
  }, settings.opportunityStatus)];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, info.map((section, index) => /*#__PURE__*/React.createElement(SummaryBox, _extends({
    key: index
  }, section))));
});
export default Summary;